/*

https://tailwindui.com/components/application-ui/layout/containers

*/

export { default } from "./container";
export { default as styles } from "./container.styles";
